import { CustomSelectProps } from 'components/CustomSelect/CustomSelect.props';
import useCompanyListOptions from 'pages/Waterfall/components/CompanyList/useCompanyListOptions';
import WaterfallSearchableCellSelect from 'pages/Waterfall/components/WaterfallSearchableCellSelect';

const CompanyList = (props: CustomSelectProps) => {
  const { cell, onCommit, onRevert } = props;

  const { options } = useCompanyListOptions();

  return (
    <WaterfallSearchableCellSelect
      cell={cell}
      emptyMessage="No companies found"
      id="company-list"
      itemLabelPlural="companies"
      itemLabelSingular="company"
      onCommit={onCommit}
      onRevert={onRevert}
      options={options}
      searchPlaceholder="Find a Company"
    />
  );
};

export default CompanyList;
